














import { Component, Prop, Vue } from 'vue-property-decorator';
import { EnumPlans } from '@/enums/Plans';
import { hasPlanAccess } from '@/common/access';

@Component
export default class Checkbox extends Vue {
  @Prop() private value: boolean;
  @Prop() private label: string;
  @Prop() tag?: string;
  @Prop({ default: null }) plan?: EnumPlans;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) dark: boolean;
  @Prop({ default: 0 }) tabindex: number;

  toggle() {
    if (this.disabled) {
      return;
    }
    this.$emit('change', !this.value);
  }

  get tagText(): string {
    return this.plan || this.tag;
  }

  get showTag(): boolean {
    return this.plan ? !hasPlanAccess(this.plan) : !!this.tag;
  }
}
